import { IsString, IsNotEmpty } from 'class-validator';

export class EditGroupTypeDTO {
  public icon! : string | null;

  @IsNotEmpty()
  @IsString()
  public name! : string;
}
